module.exports = __webpack_public_path__ + "b42f0d0f9809a6262cabee55a9038b2c.webm";